import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { HouseholdIdSchema } from "../../Households/schemas";
import { AdvisorId, ClientId, DateSchema, Prefix, Suffix, } from "../../Types";
import ValidationError from "../../ZodError";
const NameSchema = z.object({
    first: z.string(),
    last: z.string(),
    middle: z.string().nullable(),
    prefix: Prefix.nullable(),
    suffix: Suffix.nullable(),
});
export const HouseholdMembershipSchema = z.object({
    householdId: HouseholdIdSchema,
    householdName: z.string(),
});
export const ClientSchema = z.object({
    advisorId: AdvisorId,
    clientId: ClientId,
    name: NameSchema,
    emailAddress: z.string(),
    registeredTime: DateSchema,
    phoneNumber: z.string().nullable(),
    lastLoginTime: DateSchema.nullable(),
    householdMemberships: HouseholdMembershipSchema.array().nullish(),
});
const ResponseSchema = z.object({
    clients: ClientSchema.array(),
});
export const url = () => {
    return environment() === "PROD"
        ? "https://middleware.prod.farther.com/entity/v1/clients"
        : "https://middleware.uat.farther.com/entity/v1/clients";
};
export default async function getAdvisorClients(config) {
    const { data } = await axios.get(url(), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
    const decoded = ResponseSchema.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getAdvisorClients] Could not parse";
        errorLog("getAdvisorClients", `${JSON.stringify(decoded.error.issues)}`);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getAdvisorClients.js.map